import { Box } from '@mui/material';
import { useEffect, useState } from 'react';

import { ClientSecretsForm } from '../../../../../../../../common/client-secrets/clientSecretsForm';
import { AlertAfterSuccefullyGetSecretsInRegenerateForm } from '../../../../../../../../common/common-alert-messages';

interface Props {
  clientId: string;
  clientSecret: string;
  handleClose: () => void;
  handleUnlock: () => void;
  handleLock: () => void;
}
const NewSecrets = ({ clientId, clientSecret, handleClose, handleUnlock, handleLock }: Props) => {
  const [saved, setSaved] = useState<boolean>(false);

  useEffect(() => {
    if (saved) {
      handleUnlock();
    }

    if (!saved) {
      handleLock();
    }
  }, [handleLock, handleUnlock, saved]);

  return (
    <>
      <Box mb={2}>
        <AlertAfterSuccefullyGetSecretsInRegenerateForm />
      </Box>
      <ClientSecretsForm
        clientId={clientId}
        clientSecret={clientSecret}
        clientIdAndSecretSaved={saved}
        toggleClientIdAndSecretSaved={() => {
          setSaved(!saved);
        }}
        handleSubmit={handleClose}
        submitText="Close and back to the Developer Portal"
      />
    </>
  );
};

export default NewSecrets;
